import React from "react";
import trans from "../../../../../utils";
import ObjectSelectedRows from "../ObjectSelectedRows";

export default function SelectedDeviceInf({ values, device, show }) {
	const lang = localStorage.getItem("lang") || "en";
	console.log("Device", device);
	console.log("Values", values);
	const getTimeDifference = (lastUpdate) => {
		if (!lastUpdate) return "N/A";

		const now = new Date();
		const updateDate = new Date(lastUpdate);
		const diffInSeconds = Math.floor((now - updateDate) / 1000);

		if (diffInSeconds < 60) return "Just now";
		if (diffInSeconds < 3600)
			return `${Math.floor(diffInSeconds / 60)} ${trans("mins ago")}`;
		if (diffInSeconds < 86400)
			return `${Math.floor(diffInSeconds / 3600)} ${trans("hours ago")}`;
		if (diffInSeconds < 604800)
			return `${Math.floor(diffInSeconds / 86400)} ${trans("days ago")}`;
		if (diffInSeconds < 2592000)
			return `${Math.floor(diffInSeconds / 604800)} ${trans("weeks ago")}`;
		return `${Math.floor(diffInSeconds / 2592000)} ${trans("months ago")}`;
	};

	const lastUpdateText = getTimeDifference(values?.device?.lastUpdate);
	return (
		<div>
			<div className="object-body-title">
				<div className="fs-16 fw-600" role="button">
					{trans("Device Details")}
				</div>
			</div>

			<div className="object-selected-details">
				<div className="flex-center mb-2">
					<img
						src={`${process.env.PUBLIC_URL}/assets/New/smart-phone-01.svg`}
						alt="device"
						style={{
							border: "1px solid #F5F5F5",
							borderRadius: "8px",
							padding: "4px",
						}}
					/>
					<div className={`${lang === "en" ? "ms-3" : "me-3"}`}>
						<div className="fs-16 fw-600 neutral-700">{values?.name}</div>
						<div className="fs-14 fw-400 neutral-500">{values?.brand}</div>
					</div>
				</div>
				<ObjectSelectedRows title={trans("Device Name")} item={values?.name} />
				<ObjectSelectedRows
					title={trans("Device App Version")}
					item={values?.device?.appVersion}
				/>{" "}
				<ObjectSelectedRows
					title={trans("Device OS Version")}
					item={values?.device?.osVersion}
				/>
				<ObjectSelectedRows
					title={trans("Device Id")}
					item={values?.device?.deviceId}
				/>
				<ObjectSelectedRows
					title={trans("Device Brand")}
					item={values?.device?.deviceBrand}
				/>
				<ObjectSelectedRows
					title={trans("Device Model")}
					item={values?.device?.deviceModel}
				/>
				<ObjectSelectedRows
					title={trans("Device Status")}
					item={values?.device?.deviceStatus}
				/>
				<ObjectSelectedRows
					title={trans("Last Update")}
					item={lastUpdateText}
				/>
			</div>
		</div>
	);
}
